module.exports = __webpack_public_path__ + "static/media/zoom-in-icon.42660eb1.svg";